import { cx } from '@libs/classnames';

import styles from './BoardColorCircle.module.css';

export function BoardColorCircle({
  className,
  color,
}: {
  className?: string;
  color: 'white' | 'black';
}) {
  return (
    <span
      className={cx(className, styles.color, color === 'white' ? styles.is_white : styles.is_black)}
    />
  );
}
